import { makeStyles } from 'tss-react/mui';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles({ name: 'AsideSection' })((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: 282,
        minWidth: 282,
        padding: '24px 24px 0 24px',
        flex: 0,
        gap: 8,
        borderLeft: '1px solid #E0E0E0',
        overflowY: 'auto',
        scrollbarWidth: 'none',
        ['&::-webkit-scrollbar']: {
            display: 'none'
        }
    },
    tags: {
        marginTop: 12,
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            marginTop: 0,
            marginBottom: 8
        }
    },
    toolbar: {
        marginTop: 'auto',
        position: 'sticky',
        bottom: 0,
        paddingBottom: 24,
        backdropFilter: 'blur(1px)'
    }
}));
